import script from "./SocialIcons.vue?vue&type=script&lang=ts&setup=true"
export * from "./SocialIcons.vue?vue&type=script&lang=ts&setup=true"

import "./SocialIcons.vue?vue&type=style&index=0&id=089ffec4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-089ffec4"]])

export default __exports__